export const IS_LOADING = 'renewalsPortal/IS_LOADING';
export const OPEN_VALIDATION_RENEWAL = 'renewalsPortal/OPEN_VALIDATION_RENEWAL';
export const CLOSE_VALIDATION_RENEWAL =
  'renewalsPortal/CLOSE_VALIDATION_RENEWAL';
export const SET_SELECTED_BRANCH_ROUTE_ID =
  'renewalsPortal/SET_SELECTED_BRANCH_ROUTE_ID';
export const SET_SELECTED_DAY = 'renewalsPortal/SET_SELECTED_DAY';
export const UPDATE_RENEWAL = 'renewalsPortal/UPDATE_RENEWAL';
